module.exports = __webpack_public_path__ + "static/media/armann.776f50df.svg";